import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import YBCForm from './your-birth-chart/form';
import Landing from './your-birth-chart/landing';
import Navigation from './shared/ebr-navigation';
import Glossary from './shared/glossary';
import PrintIcon from './shared/print-icon';
import _ from 'underscore';
import dayjs from 'dayjs';
import { reportGoTo } from '../components/shared/accordion-scroll';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.mainnavs = [
            {
                text: 'Your Birth Chart',
                slug: 'your-birth-chart',
            },
            {
                text: 'Your Report',
                slug: 'your-report',
            },
            {
                text: 'Glossary',
                slug: 'glossary',
            },
        ];

        props.cordialBrowse();

        this.state = {
            loading: props.logged_in,
        };

        if (props.logged_in) {
            props.getProfiles();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.report != this.props.report) {
            this.setState({ loading: false });
        }

        if (nextProps.profiles != this.props.profiles && nextProps.profiles) {
            this.props.userUpdate({ selected_profile: nextProps.profiles[0] });
            this.setState({ loading: false });
        }

        if (nextProps.profile != this.props.profile) {
            if (nextProps.profile && nextProps.profile.birth_city_id && nextProps.profile.birth_city_id != '') {
                this.setState({ loading: true });
                this.props.getYourBirthChart();
            }
        }

        if (nextProps.logged_in && !this.props.logged_in) {
            this.setState({ loading: true });
            this.props.getProfiles();
        } else if (!nextProps.logged_in && this.props.logged_in) {
            this.props.clearReport();
        }
    }

    render({ logged_in, report }, { loading }) {
        if (loading) {
            return [
                <h1 className='has-text-center'>Your Birth Chart</h1>,
                <your-birth-chart className='loading'>
                    <img
                        src='https://gfx.tarot.com/images/navigation/icons/wheel.svg'
                        className='loader'
                        loading='lazy'
                        alt='Your Birth Chart'
                        height='auto'
                        width='auto'
                    />
                </your-birth-chart>,
            ];
        }

        if (logged_in && report) {
            if (report.error) {
                return [
                    <h1 className='has-text-center'>Your Birth Chart</h1>,
                    <your-birth-chart className='landing'>
                        <div>
                            <p>Whoops!</p>
                            <p>It looks like we could not generate Your Birth Chart.</p>
                            <p>Let's try to fix this:</p>
                            <ul className='has-list-style-type-decimal has-margin-50-left has-margin-30-bottom'>
                                <li>Please visit your member profile settings
                                    <a href='/member/settings/profiles-manager'> here</a>
                                </li>
                                <li>Scroll down to update your birth city</li>
                                <li>Reselect your birth city</li>
                                <li>Save your updated profile</li>
                            </ul>
                            <p>If you are still receiving this message please contact
                                <a href='mailto:support@tarot.com'> support@tarot.com</a>.
                            </p>
                        </div>
                    </your-birth-chart>,
                ];
            }

            return (
                <your-birth-chart className='landing'>
                    <Navigation mainnavs={this.mainnavs} />
                    <Landing />
                    {this.renderSample()}
                    <Glossary selector='essential-birth-report' />
                    {this.renderFooter()}
                    {this.renderPrintFooter()}
                </your-birth-chart>
            );
        }

        return (
            <your-birth-chart>
                <h1 className='has-text-center'>Your Birth Chart</h1>
                <YBCForm />
            </your-birth-chart>
        );
    }

    renderSample = () => {
        const is_shown = this.props.route && this.props.route.match(/^your-report/);

        return (
            <ebr-report id='your-report' className={is_shown ? 'is-shown' : null}>
                <section
                    id='your-report-about-sample'
                    className={is_shown ? 'is-shown' : null}
                >
                    <h1>About Your Sample Chapter</h1>
                    <p>
                        This free chapter of your Birth Chart Reading illuminates your inner self with a look at the
                        Sun in your birth chart and how it impacts your life today. The Sun's location in your chart
                        determines the answer to that common question, “What’s your sign?” but it can also tell us so
                        much more! Read on for a taste of the insight and advice you'll find on your cosmic journey
                        with Tarot.com.
                    </p>
                    <p className='is-hidden-print has-text-center'>
                        <a
                            className='button-havelock-blue has-arrow'
                            href='/readings-reports/astrology-reports/essential-birth-chart'
                            onClick={() => this.props.trackEvent([
                                'Birth Chart',
                                'Click',
                                'Get Full Report',
                                'Readings_free-birth-chart-redux:Interp_GetFullReport',
                            ])}
                        >
                            GET MY FULL REPORT
                        </a>
                    </p>
                </section>
            </ebr-report>
        );
    }

    renderFooter = () => {
        if (!this.props.route || (!this.props.route.match(/^your-report/) && !this.props.route.match(/^glossary/))) {
            this.prev_link = {
                href: 'glossary',
                text: 'Glossary',
            };

            this.next_link = {
                href: 'your-report',
                text: 'Your Report',
            };
        } else if (this.props.route.match(/^your-report/)) {
            this.prev_link = {
                href: 'your-birth-chart',
                text: 'Your Birth Chart',
            };

            this.next_link = {
                href: 'glossary',
                text: 'Glossary',
            };
        } else if (this.props.route.match(/^glossary/)) {
            this.getGlossaryLinks();
        }

        if (this.prev_link && this.next_link) {
            return (
                <section className='ebr-footer is-hidden-print'>
                    <row className='is-aligned-center'>
                        <column className='is-4 is-5-mobile has-padding-5-left-mobile'>
                            <a
                                href={`#${this.prev_link.href}`}
                                className='has-text-boulder'
                                onClick={reportGoTo}
                            >
                                <span className='left-arrow'>&#9656;</span> {this.prev_link.text}
                            </a>
                        </column>
                        <column className='is-4 is-2-mobile has-text-center'>
                            <PrintIcon selector='your-birth-chart' />
                        </column>
                        <column className='is-4 is-5-mobile has-text-right has-padding-5-right-mobile'>
                            <a
                                href={`#${this.next_link.href}`}
                                className='has-text-boulder'
                                onClick={reportGoTo}
                            >
                                {this.next_link.text} <span>&#9656;</span>
                            </a>
                        </column>
                    </row>
                </section>
            );
        }

        return (
            <row className='is-aligned-center is-hidden-print ebr-footer'>
                <column className='is-12 has-text-center'>
                    <PrintIcon />
                </column>
            </row>
        );
    }

    renderPrintFooter = () => {
        return (
            <section className='ebr-print-footer is-visible-print'>
                <row className='is-aligned-center'>
                    <column className='is-4 has-padding-15-left'>
                        {this.props.report.product.display.name}
                    </column>
                    <column className='is-4 has-text-center'>
                        <img
                            src='https://gfx.tarot.com/images/site/logo/logo.svg'
                            alt='Tarot.com'
                        />
                    </column>
                    <column className='is-4 has-text-right has-padding-15-right'>
                        © Zappallas USA {dayjs().year()}
                    </column>
                </row>
            </section>
        );
    }

    getReportLinks = () => {
        let your_report_links = [];

        this.props.report.product.navigator.map(section => {
            if (section.prefix && section.prefix != '0:' && section.code != 'glossary') {
                your_report_links.push({
                    text: `${section.prefix.replace(/:/, '.')} ${section.long_name}`,
                    href: `your-report-${section.code.replace(/_/g, '-')}`,
                });
            }
        });

        if (this.props.route == 'your-report' || this.props.route.match(your_report_links[0].href)) {
            this.prev_link = {
                text: 'Your Birth Chart',
                href: 'your-birth-chart',
            };

            this.next_link = {
                text: your_report_links[1].text,
                href: your_report_links[1].href,
            };
        } else {
            your_report_links.forEach((yr, i) => {
                if (this.props.route.match(yr.href)) {
                    this.prev_link = {
                        text: your_report_links[i - 1].text,
                        href: your_report_links[i - 1].href,
                    };

                    if (this.props.route.match(yr.href) && i != your_report_links.length - 1) {
                        this.next_link = {
                            text: your_report_links[i + 1].text,
                            href: your_report_links[i + 1].href,
                        };
                    } else {
                        this.next_link = {
                            text: 'Glossary',
                            href: 'glossary',
                        };
                    }
                }
            });
        }
    }

    getGlossaryLinks = () => {
        const glossary = [
            {
                text: 'Planets',
                href: 'glossary-planets',
            },
            {
                text: 'Elements',
                href: 'glossary-elements',
            },
            {
                text: 'Houses & Meaning',
                href: 'glossary-houses-meaning',
            },
            {
                text: 'Aspects',
                href: 'glossary-aspects',
            },
        ];

        if (this.props.route && this.props.route.match(/^glossary/)) {
            if (this.props.route == 'glossary' || this.props.route == glossary[0].href) {
                this.prev_link = {
                    href: 'your-report',
                    text: 'Your Report',
                };

                this.next_link = {
                    href: glossary[1].href,
                    text: glossary[1].text,
                };
            } else if (this.props.route == glossary[3].href) {
                this.prev_link = {
                    href: glossary[2].href,
                    text: glossary[2].text,
                };

                this.next_link = {
                    href: 'your-birth-chart',
                    text: 'Your Birth Chart',
                };
            } else {
                glossary.map((item, i) => {
                    if (this.props.route == item.href) {
                        this.prev_link = {
                            href: glossary[i - 1].href,
                            text: glossary[i - 1].text,
                        };

                        this.next_link = {
                            href: glossary[i + 1].href,
                            text: glossary[i + 1].text,
                        };
                    }
                });
            }
        }
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    profile: state.user && state.user.selected_profile,
    profiles: state.user && state.user.profiles,
    submitting: state.product && state.product.submitting,
    report: state.report,
    route: state.route,
});

const mapDispatchToProps = (dispatch) => ({
    getProfiles: () => dispatch({ type: 'member:get-profiles' }),
    getYourBirthChart: () => dispatch({ type: 'product:get-your-birth-chart' }),
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
    cordialBrowse: () => dispatch({ type: 'cordial:browse' }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    clearReport: () => dispatch({ type: 'report:clear' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
